import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Api from './api';
import * as Actions from './actions';

const handleDiaperEvent = (childId, actionType, diaperingType, note, occurredOn) =>
    Api.registerAction(childId, actionType, {diaperingType, note}, occurredOn).catch(e =>
        Observable.of(Actions.diaperFailure.action(e)),
    );

const diaper = action$ =>
    action$
        .ofType(Actions.diaper.type)
        .mergeMap(({payload}) => {
            const {childIds, actionType, diaperingType, note, time} = payload;
            const observables = childIds.map(childId =>
                handleDiaperEvent(childId, actionType, diaperingType, note, time),
            );
            return Observable.combineLatest(...observables).map(responses => ({responses}));
        })
        .flatMap(({responses}) => {
            const failureEvent = responses.find(r => r.type === Actions.diaperFailure.type);
            if (failureEvent) {
                // If any of the requests fail we emit a single failure event.
                return [failureEvent];
            } else {
                return [
                    GlobalEventActions.updateSuccess.action(i18next.t('group_tag.diaperChangeNoted')),
                    Actions.diaperSuccess.action({}),
                ];
            }
        });

export default combineEpics(diaper);
